import { Button } from "react-bootstrap"
import "./TermsOfService.css"

const TermsOfService = (props) => {
    return(
    <div className="termsOfService">
        <h1>Terms of Service</h1>
        <p>Soundboard1 is provided by the company Modularity AS, a registered Norwegian company with number 927 587 645.</p>
        <p>You agree that Soundboard1 will store your uploaded files on their servers and are not viable for their loss.</p>
        <p>You may delete your account, and the files you upload at any time using the Soundboard1 interface.</p>
        <p>You agree that you will not upload any content that is illegal in nature.</p>
        <p>By submitting content you agree that Soundboard1, Modularity AS, and their affiliates are not responsible for the content you submit.</p>
        <p>By registering you agree that your username and an encrypted version of your password is stored in our database.</p>
        <div className="confirmationButtons">
            <Button variant="danger" onClick={props.onCancel}>Cancel</Button>
            <Button onClick={props.onAgree}>Agree</Button>
        </div>
    </div>)
}

export default TermsOfService
